module.exports = __webpack_public_path__ + "static/media/LegoDesertBattleAreaA0034_design_clean_v001.4121a301.png";